import { Components } from '@mui/material';
import { Theme } from '@mui/material/styles';

export const getIconButtonComponents = (
  theme: Theme,
): Pick<Components, 'MuiIconButton'> => ({
  MuiIconButton: {
    defaultProps: {
      disableRipple: true,
    },
    styleOverrides: {
      root: {
        boxSizing: 'border-box',
        color: theme.palette.text.default,

        '& .icon-svg': {
          color: 'currentColor',
          width: theme.lelySpacing.XL,
          height: theme.lelySpacing.XL,
        },

        '& .MuiSvgIcon-root': {
          color: 'currentColor',
          width: theme.lelySpacing.XL,
          height: theme.lelySpacing.XL,
        },
      },
    },
  },
});